export function isArray(maybeArray) {
  return Array.isArray(maybeArray);
}
export function isNotArray(maybeArray) {
  return !Array.isArray(maybeArray);
}
export function isDefined(value) {
  return typeof value !== 'undefined' && value !== null;
}
export function isEveryElementDefined(array) {
  return array.every(isDefined);
}